import React, { HTMLAttributes, useState } from 'react'

import classNames from 'classnames'

import CoverArtOverlay from '@components/shared/CoverArt/CoverArtOverlay'

interface Props extends HTMLAttributes<HTMLDivElement> {
  url?: string | null
  overlay?: string | null
  className?: string
}

const CoverArt: React.FC<Props> = ({ url, overlay, className, ...props }) => (
  <div
    {...props}
    className={classNames(
      'flex-1 max-w-[163px] max-h-[163px] overflow-hidden flex justify-center shadow-thick relative',
      className
    )}>
    <CoverArtImage url={url} />
    <CoverArtOverlay directive={overlay} />
  </div>
)
export default CoverArt

const CoverArtImage: React.FC<{ url?: string | null }> = ({ url }) => {
  const [imgLoaded, setImgLoaded] = useState(false)

  if (!url) {
    return <div className="w-full h-[163px]" />
  }
  return (
    <img
      src={url}
      alt="cover art"
      draggable={false}
      className={classNames(
        'w-full h-full transition-opacity duration-250 object-cover',
        imgLoaded ? 'opacity-100' : 'opacity-0'
      )}
      onLoad={() => setImgLoaded(true)}
    />
  )
}
